import * as React from 'react'

import classnames from 'classnames'
import { css } from 'emotion'

import ThemeConsumer from 'embed/components/ThemeConsumer'

const styles = require('embed/components/LoadingIndicator/styles.scss')

export const Spinner: React.SFC = () => (
  <ThemeConsumer>
    {({ ctaStyles }) => (
      <div
        data-test-id="spinner"
        className={classnames(
          styles.spinner,
          css`
            border-left-color: ${ctaStyles?.backgroundColor};
          `,
        )}
      />
    )}
  </ThemeConsumer>
)
